import TextField, { TextFieldProps } from '@mui/material/TextField';
import { useEffect, useRef } from 'react';
import { Controller } from 'react-hook-form';

import { DataProps } from '@/common/types';
import { FormElementProps } from '@/components/form/types';

interface FormInputTextProps extends FormElementProps {
    inputFieldProps?: TextFieldProps & DataProps;
    defaultHelperText?: string;
    applyOnChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const FormInputText = ({
    name,
    control,
    label,
    inputFieldProps = {},
    controllerProps = {},
    defaultHelperText = '',
    applyOnChange = (val) => val.target.value,
}: FormInputTextProps) => {
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (!inputRef.current) {
            return;
        }
        const handleWheel = (e: WheelEvent) => e.preventDefault();
        inputRef.current.addEventListener('wheel', handleWheel);

        const input = inputRef.current;
        return () => {
            input?.removeEventListener('wheel', handleWheel);
        };
    }, []);

    return (
        <Controller
            name={name}
            control={control}
            {...controllerProps}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
                const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
                    const value = applyOnChange(event);
                    onChange(value);
                };
                return (
                    <TextField
                        helperText={error ? error.message : defaultHelperText}
                        size="small"
                        error={!!error}
                        onChange={handleOnChange}
                        value={value}
                        fullWidth
                        label={label}
                        variant="outlined"
                        ref={inputRef}
                        {...inputFieldProps}
                    />
                );
            }}
        />
    );
};
